// extracted by mini-css-extract-plugin
module.exports = {"footer":"style-m__footer__X28nf","footer-links":"style-m__footer-links__3GcBn"};